// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"d2d31d54","987":"e6449380"}[chunkId] + ".chunk.js";
};